<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="d-flex justify-content-between align-items-center">
        <h6>商户列表</h6>
        <div class="d-flex align-items-center">
          <input
            v-model="searchText"
            type="text"
            class="form-control form-control-sm me-2"
            placeholder="搜索商户名称/ID/手机号"
            style="width: 250px;"
            @input="handleSearch"
          />
          <button class="btn btn-sm btn-outline-secondary" @click="clearSearch" v-if="searchText">
            清除
          </button>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                [ID]商户名
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                地址/联系电话
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                状态
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                入驻时间
              </th>
              <th class="text-secondary opacity-7 text-xs font-weight-bolder">
                操作
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="merchant in currentPageMerchants" :key="merchant.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar :img="merchant.deliver_pic || defaultAvatar" size="sm" border-radius="lg" class="me-3" alt="merchant-avatar"/>
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">[{{ merchant.id }}]{{ merchant.account_holder || merchant.name }}</h6>
                    <p class="text-xs text-secondary mb-0">{{ merchant.nick_name }}</p>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ merchant.store_address || merchant.address || '暂无地址' }}</p>
                <p class="text-xs text-secondary mb-0">{{ merchant.mobile || merchant.phone || '-' }}</p>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge :color="merchant.active === 1 ? 'success' : 'danger'" variant="gradient" size="sm">
                  {{ merchant.active === 1 ? '启用' : '禁用' }}
                </soft-badge>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ formattedDate(merchant.create_time) }}</span>
              </td>
              <td class="align-middle">
                <a href="javascript:;" class="text-primary font-weight-bold text-xs" @click="goToDetail(merchant)">详情</a>
                <span class="mx-2 text-secondary">|</span>
                <a href="javascript:;" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user" @click="openEditModal(merchant)">编辑</a>
                <span class="mx-2 text-secondary">|</span>
                <a href="javascript:;" class="font-weight-bold text-xs" :class="merchant.active === 0 ? 'text-success' : 'text-danger'" @click="toggleMerchantActive(merchant)">
                  {{ merchant.active === 0 ? '启用' : '禁用' }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 编辑商户弹窗 -->
      <div
        v-if="editModalVisible"
        class="modal fade show"
        style="display: block; padding-right: 17px;"
        tabindex="-1"
        role="dialog"
        aria-hidden="false"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">编辑商户信息</h5>
            </div>
            <div class="modal-body">
              <div class="mb-3 text-sm">
                商户ID：{{ editForm.deliver_id }}
              </div>
              <div class="mb-3">
                <label class="form-label text-sm">商户名称</label>
                <input v-model="editForm.name" type="text" class="form-control" placeholder="商户名称" />
              </div>
              <div class="mb-3">
                <label class="form-label text-sm">地址</label>
                <input v-model="editForm.address" type="text" class="form-control" placeholder="地址" />
              </div>
              <div class="mb-3">
                <label class="form-label text-sm">电话</label>
                <input v-model="editForm.phone" type="text" class="form-control" placeholder="电话" />
              </div>
              <div class="mb-3">
                <label class="form-label text-sm">手机号</label>
                <input v-model="editForm.mobile" type="text" class="form-control" placeholder="手机号" />
              </div>
              <div class="mb-3">
                <label class="form-label text-sm">昵称</label>
                <input v-model="editForm.nick_name" type="text" class="form-control" placeholder="昵称" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeEditModal">取消</button>
              <button type="button" class="btn btn-primary" @click="submitEdit">保存</button>
            </div>
          </div>
        </div>
      </div>

         <!-- 分页控件 -->
      <div class="d-flex justify-content-center mt-3">
        <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1" class="btn btn-sm btn-secondary">
          上一页
        </button>
        <span class="mx-2">{{ currentPage }} / {{ totalPages }}</span>
        <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages" class="btn btn-sm btn-secondary">
          下一页
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import { getmerchlist, editMerchantInfo, setMerchantActive } from "@/api/merch.js";  // 引入商户列表接口
import dayjs from "dayjs";

export default {
  name: "merchant-all-set",
  data() {
    return {
      merchants: [],
      filteredMerchants: [],
      defaultAvatar: require("../../assets/img/merchant.png"),
      currentPage:1,
      pageSize:10,
      totalPages:1,
      totalCount:0,
      searchText: '',
      editModalVisible: false,
      editForm: {
        deliver_id: 0,
        name: '',
        address: '',
        phone: '',
        mobile: '',
        nick_name: '',
      },
    };
  },
  components: {
    SoftAvatar,
    SoftBadge,
  },
  computed: {
    currentPageMerchants(){
      // 服务端分页，直接返回当前页数据
      return this.filteredMerchants
    }
  },
  methods: {
    formattedDate(timestamp) {
      return dayjs.unix(timestamp).format('YYYY/MM/DD HH:mm:ss');
    },
    goToDetail(merchant) {
      this.$router.push('/merchants/' + merchant.id);
    },
    handleSearch() {
      this.currentPage = 1
      this.doFilter()
    },
    clearSearch() {
      this.searchText = ''
      this.handleSearch()
    },
    doFilter() {
      const keyword = this.searchText.trim().toLowerCase()
      if (!keyword) {
        this.filteredMerchants = [...this.merchants]
      } else {
        this.filteredMerchants = this.merchants.filter(m => {
          return String(m.id).includes(keyword) ||
            (m.name && m.name.toLowerCase().includes(keyword)) ||
            (m.mobile && m.mobile.includes(keyword)) ||
            (m.nick_name && m.nick_name.toLowerCase().includes(keyword)) ||
            (m.phone && m.phone.includes(keyword))
        })
      }
    },
    getMerchants() {
      getmerchlist({ page: this.currentPage, page_size: this.pageSize }).then(response => {
        if (response.code === 0 && response.desc) {
          const desc = response.desc
          this.merchants = (desc.delivers || []).map(merchant => ({
            ...merchant,
            create_time: merchant.created_date
          }))
          this.totalPages = desc.total_pages || 1
          this.totalCount = desc.total_count || 0
          this.doFilter()
        } else {
          alert("获取商户列表失败：" + response.desc)
        }
      }).catch(error => {
        console.error("获取商户列表时出错：", error)
        alert("获取商户列表失败，请稍后再试。")
      })
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.currentPage = page
      this.getMerchants()
    },

    openEditModal(merchant) {
      this.editForm = {
        deliver_id: merchant.id,
        name: merchant.name || '',
        address: merchant.address || '',
        phone: merchant.phone || '',
        mobile: merchant.mobile || '',
        nick_name: merchant.nick_name || '',
      }
      this.editModalVisible = true
    },

    closeEditModal() {
      this.editModalVisible = false
    },

    submitEdit() {
      if (!this.editForm.deliver_id) {
        alert('商户ID无效')
        return
      }
      editMerchantInfo(this.editForm).then(response => {
        if (response.code === 0) {
          alert('商户信息更新成功')
          this.closeEditModal()
          this.getMerchants()
        } else {
          alert(response.desc || '更新失败')
        }
      }).catch(error => {
        console.error('更新商户信息失败', error)
        alert('更新商户信息失败，请稍后重试')
      })
    },

    toggleMerchantActive(merchant) {
      const newActive = merchant.active === 0 ? 1 : 0
      const actionText = newActive === 1 ? '启用' : '禁用'
      if (!confirm(`确认要${actionText}商户 "${merchant.name || merchant.id}" 吗？`)) {
        return
      }
      setMerchantActive({ deliver_id: merchant.id, active: newActive }).then(response => {
        if (response.code === 0) {
          alert(`商户${actionText}成功`)
          this.getMerchants()
        } else {
          alert(response.desc || '操作失败')
        }
      }).catch(error => {
        console.error('设置商户状态失败', error)
        alert('操作失败，请稍后重试')
      })
    },
  },
  mounted() {
    this.getMerchants()
  }
};
</script>
